// Quick view product pop-up NYCO


//import { CartUpdateEvent } from '@theme/events';

const sizeToShortValueMap = {
  'xxsmall' : 'XXS', 'xsmall' : 'XS', 'small' : 'S', 'medium' : 'M', 'large' : 'L', 'xlarge' : 'XL', 'xxlarge' : 'XXL', 'xxxlarge' : 'XXXL', 'non sized' : 'One Size'
}

function initializeQuickView() {
  const quickViewModalEl = document.querySelector('.quick-view-modal');
  if (!quickViewModalEl || quickViewModalEl.length === 0) {
    const modal = createQuickViewModal();
    document.body.appendChild(modal);
  }

  // document.querySelectorAll('[data-quick-view]').forEach(button => {
  //   button.addEventListener('click', async () => {
  //     const handle = button.getAttribute('data-product-handle');
  //     const discountTags = button.getAttribute('data-discount-tags');
  //     const productTitle = button.getAttribute('data-product-title');
  //     const productPrice = button.getAttribute('data-price');
  //     const productImage = button.getAttribute('data-image');      
  //     window.GTMEventBus.publish(eventConstants.QUICK_VIEW, {productTitle, productPrice, productImage});
  //     const product = await fetchProduct(handle);
  //     renderQuickViewModal(product, discountTags);
  //     openModal();
  //     // window.GTMEventBus.publish(eventConstants.VIEW_ITEM, {product, selectedVariant});
  //   });
  // });
}

let currentProduct = null;
let frenzySelectedVariant = null;
let selectedOptions = {};

let colorThumbnailIndices = {};

async function fetchProduct(handle) {
  const res = await fetch(`/products/${handle}.js`);
  if (!res.ok) throw new Error(`Failed to load ${handle}`);
  return await res.json();
}

function createQuickViewModal() {
  const wrapper = document.createElement('div');
  wrapper.className = 'quick-view-modal fixed inset-0 bg-black/50 display_none z-50 flex items-baseline lg:items-center justify-right lg:justify-center';
  wrapper.innerHTML = `
    <div class="quick-view-content bg-white max-w-[860px] pt-4 p-1 sm:p-4 relative overflow-y-auto h-full lg:h-auto lg:max-h-[80vh] w-[80%]">
      <button class="quick-view-close absolute top-4 right-4 text-gray-600 hover:text-black text-2xl">&times;</button>
      <div class="px-4 pb-8 grid grid-cols-1 lg:grid-cols-2">
        <div class="quick-view-media pt-8 lg:pt-4 lg:pr-[60px] flex flex-col">
          <div class="main-image relative mb-4 h-auto cursor-zoom-in">
            <img src="" alt="Main Image" class="w-full h-auto object-cover" id="quick-view-main-img"></img>
            <div id="video_container" class="relative inline-block" style="display_none">              
            </div>
          </div>
          <div class="quick-view-slider relative overflow-hidden"><!-- Desktop arrows -->
            <button class="qv-arrow qv-prev lg:flex" aria-label="Previous image">
              <svg fill="none" width="20" height="20" viewBox="0 0 20 20">
                <path d="M12 15l-5-5 5-5" stroke="currentColor" stroke-width="1" fill="none" stroke-linecap="round"></path>
              </svg>
            </button>
            <button class="qv-arrow qv-next lg:flex" aria-label="Next image">
              <svg fill="none" width="20" height="20" viewBox="0 0 20 20">
                <path d="M8 5l5 5-5 5" stroke="currentColor" stroke-width="1" fill="none" stroke-linecap="round"></path>
              </svg>
            </button>
            <div class="slider-track flex overflow-x-auto snap-x snap-mandatory scroll-smooth"
                id="quick-view-slider-track">
            </div>
            <div class="slider-dots flex justify-center gap-2 mt-3" id="quick-view-slider-dots"></div>
          </div>
        </div>
      
        <div class="quick-view-info pt-8 md:pt-4">
          <h1 class="font-medium text-[16px]/[20px] lg:text-[25px]/[25px] mb-2" style="letter-spacing: .02em;"
            id="quick-view-title"></h1>
          <div class="mb-5">
            <span class="line-through text-sm opacity-[0.4]" id="quick-view-compare"></span>
            <span class="text-sm ml-1" id="quick-view-price"></span>
          </div>
          <!--<div id="discount-tags" class="w-full lg:w-auto inline-block text-[12px] lg:text-[10px] bg-[#E6E5E5] text-cocoa px-3 py-3 mb-3 lg:px-1 lg:py-[2px] rounded-sm mt-3 lg:mt-0 order-4 display_none" 
          style="letter-spacing: .02em; line-height: 15px; font-weight: 600;"> 
          </div>-->
          <div class="mb-7" id="quick-view-options"></div>
          <button id="quick-view-add-btn" class="w-full bg-black text-white py-3 text-center uppercase hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed">
            Add to Bag
          </button>
          <div class="product__discount-code text-center mt-6 display_none"></div>
          <div class="mt-6 pt-5 border-t border-dusty underline">
            <button class="view_product_link text-sm font-semibold underline uppercase">
              View All Product Details
            </button>
          </div>
        </div>
      </div>  
    </div>
  `;

  wrapper.style.display = 'none';
  // window.addEventListener("load", () => {
    // wrapper.style.display = '';
  // });
  wrapper.querySelector('.view_product_link').addEventListener('click', () => window.location.href = currentProduct?.url)
  wrapper.querySelector('.quick-view-close').addEventListener('click', closeModal);
  wrapper.addEventListener('click', (e) => {
    wrapper.style.display = '';
    if (e.target === wrapper) closeModal(e);
  });
  return wrapper;
}

const formatMoney = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount / 100);
};
let colorOptionIdx = 0;
let sizeOptionIdx = 0;
let colorSizeToVariantMap = {};
let colorToAvailableSizes = {};
let sizeToAvailableColors = {};
let unavailableColors = [];
let unavailableSizes = [];
let availableColors = [];
let availableSizes = [];
// const colorToSwatchImage = {};
function generateColorSizeMaps(product) {
  colorOptionIdx = product?.options.filter(option => option.name.toLowerCase() === 'color')?.[0]?.position;
  sizeOptionIdx = product?.options.filter(option => option.name.toLowerCase() === 'size')?.[0]?.position;  
  product.variants.forEach(v => {
    const colorWithFamily = v[`option${colorOptionIdx}`];
    const size = v[`option${sizeOptionIdx}`];
    if (v.available) {
      colorSizeToVariantMap[`${colorWithFamily} - ${size}`] = v.id;
      if (!colorToAvailableSizes.hasOwnProperty(colorWithFamily)) {
        colorToAvailableSizes[colorWithFamily] = [];
      }
      if (!colorToAvailableSizes[colorWithFamily].includes(size)) {
        colorToAvailableSizes[colorWithFamily].push(size);
      }
      if (!sizeToAvailableColors.hasOwnProperty(size)) {
        sizeToAvailableColors[size] = [];
      }
      if (!sizeToAvailableColors[size].includes(colorWithFamily)) {
        sizeToAvailableColors[size].push(colorWithFamily);
      }
    } else {
      if (!unavailableColors.includes(colorWithFamily)) unavailableColors.push(colorWithFamily);
      if (!unavailableSizes.includes(size)) unavailableSizes.push(size);
    }
  });
  availableColors = Object.keys(colorToAvailableSizes);
  availableSizes = Object.keys(sizeToAvailableColors);
  unavailableColors = unavailableColors.filter(color => !availableColors.includes(color));
  unavailableSizes = unavailableSizes.filter(size => !availableSizes.includes(size));
  console.log('done');
}

function renderQuickViewModal(product, discountTags) {
  colorThumbnailIndices = {};

  colorSizeToVariantMap = {};
  colorToAvailableSizes = {};
  sizeToAvailableColors = {};
  unavailableColors = [];
  unavailableSizes = [];
  availableColors = [];
  availableSizes = [];

  currentProduct = product;
  generateColorSizeMaps(product);
  selectedOptions = {};
  const colorSwatchMap = {};
  const mainImg = document.getElementById('quick-view-main-img');
  const videoContainer = document.querySelector('#video_container');
  const thumbnails = document.querySelector('.thumbnail-list');
  const thumbPrev = document.querySelector('.thumb-prev');
  const thumbNext = document.querySelector('.thumb-next');
  // const titleEl = document.getElementById('quick-view-title');
  const modal = document.querySelector('.quick-view-modal');

  const titleEl = modal.querySelector('#quick-view-title');

  const compareEl = document.getElementById('quick-view-compare');
  const priceEl = document.getElementById('quick-view-price');
  const discountTagsEl = document.querySelector('.product__discount-code');
  const optionsEl = document.getElementById('quick-view-options');
  const addBtn = document.getElementById('quick-view-add-btn');
  const videoPlaceHolderPoster =
    'https://cdn.shopify.com/s/files/1/0552/9829/3930/files/play-button-new.png?v=1704954290';
  let mediaCounter = 0;
    
  titleEl.textContent = product.title;
  priceEl.textContent = formatMoney(product.price);
  compareEl.textContent = product.compare_at_price ? formatMoney(product.compare_at_price) : '';

  if (discountTags?.trim()) {
    const discountTagsStr = discountTags.replaceAll(',', '<br>');
    discountTagsEl.innerHTML = discountTagsStr;
    discountTagsEl.classList.remove('display_none');
  }
  // ==================================================
  // Helper functions for availability
  // ==================================================
  /* const getAvailableOptions = (optionIndex, value) => {
    return product.variants.filter(v => v.available && v.options[optionIndex] === value);
  };

  const isVariantAvailable = (colorValue, sizeValue) => {
    return product.variants.some(v => 
      v.options[colorOptionIdx] === colorValue &&
      v.options[sizeOptionIdx] === sizeValue &&
      v.available
    );
  }; */

  // ==================================================
  // Render Thumbnails / Slider Carousel
  // ==================================================
  const sliderTrack = document.getElementById('quick-view-slider-track');
  const dotsContainer = document.getElementById('quick-view-slider-dots');

  sliderTrack.innerHTML = '';
  dotsContainer.innerHTML = '';
  colorThumbnailIndices = {};

  let slides = [];

  product.media.forEach((media) => {
    // ✅ capture swatch images
    if (media?.alt?.startsWith('#swatch')) {
      colorSwatchMap[media.alt.toLowerCase()] = media.src;
      return;
    }

    const slideIndex = slides.length;

    const slide = document.createElement('div');
    slide.className = 'quick-view-slide flex-shrink-0 w-full';

    if (media.media_type === 'image') {
      slide.innerHTML = `<img src="${media.src}" class="w-full h-auto object-cover" draggable="false" />`;
    } else {
      slide.innerHTML = `
        <video autoplay muted loop playsinline class="w-full h-auto object-cover">
          <source src="${media.sources?.[0].url}" type="video/mp4">
        </video>
      `;
    }

    sliderTrack.appendChild(slide);
    slides.push(slide);

    // ✅ dots
    const dot = document.createElement('button');
    dot.className = 'slider-dot';
    dot.dataset.index = slideIndex;

    dot.addEventListener('click', () => {
      goToSlide(slideIndex);
    });

    dotsContainer.appendChild(dot);

    // ✅ color → slide mapping
    if (media.alt) {
      if (!colorThumbnailIndices[media.alt]) {
        colorThumbnailIndices[media.alt] = [];
      }
      colorThumbnailIndices[media.alt].push(slideIndex);
    }
  });

  // ==================================================
  // Slider helpers
  // ==================================================
  function goToSlide(index) {
    const slideWidth = sliderTrack.clientWidth;
    sliderTrack.scrollTo({
      left: slideWidth * index,
      behavior: 'smooth'
    });
    setActiveDot(index);
    currentSlideIndex = index;
  }

  function goNext() {
    if (currentSlideIndex < slides.length - 1) {
      goToSlide(currentSlideIndex + 1);
    }
  }

  function goPrev() {
    if (currentSlideIndex > 0) {
      goToSlide(currentSlideIndex - 1);
    }
  }

  function setActiveDot(index) {
    [...dotsContainer.children].forEach(dot => dot.classList.remove('active'));
    dotsContainer.children[index]?.classList.add('active');
  }

  // ==================================================
  // Scroll → dot sync
  // ==================================================
  sliderTrack.addEventListener('scroll', () => {
    const slideWidth = sliderTrack.clientWidth;
    const index = Math.round(sliderTrack.scrollLeft / slideWidth);

    if (index !== currentSlideIndex) {
      currentSlideIndex = index;
      setActiveDot(index);
    }
  });

  // Init first dot
  dotsContainer.children[0]?.classList.add('active');

  // ✅ Bind desktop arrows (AFTER DOM exists)
  document.querySelector('.qv-prev')?.addEventListener('click', goPrev);
  document.querySelector('.qv-next')?.addEventListener('click', goNext);

  // ==================================================
  // ❌ REMOVE mouse drag (desk





  // ==================================================
  // Render Color and Size Options with stock logic
  // ==================================================
  optionsEl.innerHTML = '';
  let colorWrapper, sizeWrapper;
  let colorValuesDiv, sizeValuesDiv;
  let selectedColor = null;
  let selectedSize = null;

  product.options.forEach((option, optionIndex) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'mb-6';
    const label = document.createElement('legend');
    label.innerHTML = `${option.name}<span class="pl-2"></span>`;
    label.className = `${option.name.toLowerCase()} option_label uppercase block mb-2 font-semibold text-xs sm:text-sm`;
    label.style = 'letter-spacing: .02em';
    wrapper.appendChild(label);

    const valuesDiv = document.createElement('div');
    
    if (option.name.toLowerCase().includes('color')) {
      // valuesDiv.className = 'color-swatch-wrapper';
      // colorOptionIdx = optionIndex;
      colorWrapper = wrapper;
      colorValuesDiv = valuesDiv;

      option.values.forEach(value => {
        if (availableColors?.length > 0 && unavailableColors?.includes(value)) return; // skip fully unavailable color
        
        const btn = document.createElement('button');
        btn.className = 'color-swatch rounded-full mr-2 border border-cocoa p-[2px]';
        btn.style.backgroundColor = value.toLowerCase();
        btn.dataset.value = value;
        let colorNameFamilyArr = value?.split(" - ");
        const colorName = (colorNameFamilyArr && colorNameFamilyArr.length > 1 ? colorNameFamilyArr[1].toUpperCase() : value.toUpperCase());
        // const swatchImage = colorSwatchMap[`#swatch_${colorName}`];
        const swatchKey = `#swatch_${colorName}`.toLowerCase();
        const swatchImage = colorSwatchMap[swatchKey];
        
        // btn.innerHTML = `<img class="rounded-full border h-[30px] w-[30px]" src="${swatchImage}" width="30" height="30" alt="${colorName}" loading="lazy" decoding="async">`;
        btn.innerHTML = swatchImage
        ? `<img class="rounded-full border h-[30px] w-[30px]" src="${swatchImage}" alt="${colorName}">`
        : `<span class="block h-[30px] w-[30px] rounded-full" style="background:${value.toLowerCase()}"></span>`;


        btn.addEventListener('click', () => {
          colorValuesDiv.querySelectorAll('button').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          selectedColor = value;
          selectedOptions[colorOptionIdx] = value;
          updateSizeAvailability();
          updateSelectedVariant();
          updateMainImageForColor(colorName);
        });

        valuesDiv.appendChild(btn);
      });

      optionsEl.prepend(wrapper);
      wrapper.appendChild(valuesDiv);

    } else if (option.name.toLowerCase().includes('size')) {
      valuesDiv.className = 'size-wrapper';
      // sizeOptionIdx = optionIndex;
      sizeWrapper = wrapper;
      sizeValuesDiv = valuesDiv;

      option.values.forEach(value => {
        // if (unavailableSizes?.includes(value)) return; // skip fully unavailable size

        const btn = document.createElement('button');
        btn.className = 'size mb-[10px] cursor-pointer';
        const sizeShortValue = sizeToShortValueMap.hasOwnProperty(value.toLowerCase()) ? sizeToShortValueMap[value.toLowerCase()] : value;
        btn.textContent = sizeShortValue;
        btn.dataset.value = value;

        btn.addEventListener('click', () => {
          sizeValuesDiv.querySelectorAll('button').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          selectedSize = value;
          selectedOptions[sizeOptionIdx] = value;
          updateColorAvailability();
          updateSelectedVariant();
        });

        valuesDiv.appendChild(btn);
      });
      
      optionsEl.appendChild(wrapper);
      wrapper.appendChild(valuesDiv);
    }
  });
  
  // ==================================================
  // Helper: Update unavailable for sizes when color selected
  // ==================================================
  function updateSizeAvailability() {
    if (!sizeValuesDiv || !selectedColor) return;
    const availableSizes = colorToAvailableSizes?.[selectedColor];
    sizeValuesDiv.querySelectorAll('button').forEach(btn => {
      const sizeValue = btn.dataset.value;
      const available = availableSizes?.includes(sizeValue); // isVariantAvailable(selectedColor, sizeValue);
      if (!available) {
        btn.classList.add('unavailable');
        // btn.disabled = true;
      } else {
        btn.classList.remove('unavailable');
        // btn.disabled = false;
      }
    });
  }

  // ==================================================
  // Helper: Update unavailable for colors when size selected
  // ==================================================
  function updateColorAvailability() {
    if (!colorValuesDiv || !selectedSize) return;
    const availableColors = sizeToAvailableColors?.[selectedSize];
    colorValuesDiv.querySelectorAll('button').forEach(btn => {
      const colorValue = btn.dataset.value;
      const available = availableColors?.includes(colorValue); // isVariantAvailable(colorValue, selectedSize);
      if (!available) {
        btn.classList.add('unavailable');
        // btn.disabled = true;
      } else {
        btn.classList.remove('unavailable');
        // btn.disabled = false;
      }
    });
  }

  // ==================================================
  // Helper: Select default first available color & size
  // ==================================================
  let firstColorBtn = [...colorValuesDiv.querySelectorAll('button')].find(b => !b.classList?.contains('unavailable'));
  if (!firstColorBtn) {
    firstColorBtn = colorValuesDiv.querySelector('button')
  }
  if (firstColorBtn) {
    firstColorBtn.click(); // selects first color and triggers update
    let firstAvailableSize = [...sizeValuesDiv.querySelectorAll('button')].find(b => !b.classList?.contains('unavailable'));
    if (!firstAvailableSize) {
      firstAvailableSize = sizeValuesDiv.querySelector('button')
    }
    if (firstAvailableSize) {
      firstAvailableSize.click(); // selects first size for that color
    }
  }

  // ==================================================
  // Helper: Update main image for color selection
  // ==================================================
  function updateMainImageForColor(color) {
    const colorKey = `#color_${color}`;
    const indices = colorThumbnailIndices[colorKey];

    if (indices && indices.length) {
      goToSlide(indices[0]);
    }
  }



  // addBtn.disabled = true;
  addBtn.onclick = handleAddToCart;

  let currentSlideIndex = 0;

  function goToSlide(index) {
    if (!slides[index]) return;

    const slideWidth = sliderTrack.clientWidth;
    sliderTrack.scrollTo({
      left: slideWidth * index,
      behavior: 'smooth'
    });

    setActiveDot(index);
    currentSlideIndex = index;
  }
  goToSlide(0);

  function setActiveDot(index) {
    [...dotsContainer.children].forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }

}

function updateSelectedVariant() {
  const addBtn = document.getElementById('quick-view-add-btn');
  const selectedOptionKeys = Object.keys(selectedOptions);
  if (selectedOptionKeys?.length < 2) {
    addBtn.disabled = true;
    addBtn.textContent = "Sold Out"; 
    return;
  }
  
  const priceEl = document.getElementById('quick-view-price');
  const compareEl = document.getElementById('quick-view-compare');

  // const selectedOptionsKeys = Object.values(selectedOptions);
  // if (selectedValues.length !== currentProduct.options.length) {
  //   addBtn.disabled = true;
  //   return;
  // }

  const matchingVariants = currentProduct.variants.filter(v =>
    v[`option${colorOptionIdx}`] === selectedOptions[colorOptionIdx] &&
    v[`option${sizeOptionIdx}`] === selectedOptions[sizeOptionIdx] 
  );

  const availableVariant = matchingVariants.find(v => v.available) 
  const matchingVariant = availableVariant || matchingVariants?.[0];
  frenzySelectedVariant = matchingVariant;
  window.GTMEventBus?.publish(eventConstants.VIEW_ITEM, {product: currentProduct, selectedVariant: frenzySelectedVariant});
  // const colorLabel = document.querySelector('.quick-view-modal legend.color span');
  // const sizeLabel = document.querySelector('.quick-view-modal legend.size span');
  const colorLegend = document.querySelector('.quick-view-modal legend.color');
  const sizeLegend = document.querySelector('.quick-view-modal legend.size');

  const colorLabel = colorLegend?.querySelector('span');
  const sizeLabel = sizeLegend?.querySelector('span');


  let colorNameFamilyArr = selectedOptions[colorOptionIdx]?.split(" - ");
  const colorName = (colorNameFamilyArr && colorNameFamilyArr.length > 1 ? colorNameFamilyArr[1].toUpperCase() : selectedOptions[colorOptionIdx].toUpperCase());
  // colorLabel.textContent = `${colorName}`;
  // sizeLabel.textContent = `${selectedOptions[sizeOptionIdx]}`; 
  if (colorLabel) {
    colorLabel.textContent = colorName;
  }

  if (sizeLabel) {
    sizeLabel.textContent = selectedOptions[sizeOptionIdx];
  }

  if (matchingVariant) {
    addBtn.disabled = !matchingVariant.available;
    addBtn.textContent = matchingVariant.available ? "Add To Bag" : "Sold Out";
    addBtn.dataset.variantId = matchingVariant.id;
    priceEl.textContent = formatMoney(matchingVariant.price);
    compareEl.textContent = matchingVariant.compare_at_price
      ? formatMoney(matchingVariant.compare_at_price)
      : '';
  } else {
    addBtn.disabled = true;
    addBtn.textContent = "Sold Out";  
  }
}

function updateCartDrawer() {
  const currentTime = Date.now();
  import('@theme/events').then(({ CartUpdateEvent }) => {
      const cartDrawer = document.querySelector('cart-drawer-component');    
      fetch(`/cart.js?${currentTime}`)
      .then(res => res.json())
      .then(cart => {
        const itemCount = cart?.item_count + 1;
        const event = new CartUpdateEvent(cart, 'manual-trigger', {
          itemCount: cart.item_count,
          source: 'fad-refresh',
          sections: {}
        });
        document.dispatchEvent(event);
        // if (cartDrawer?.hasAttribute('auto-open')) {
        setTimeout(() => {
          closeModal();
          cartDrawer.open();
          window.GTMEventBus?.publish(eventConstants.VIEW_CART, {cart});
        }, 200);
        // }
      });
    });
    setTimeout(()=>{frenzyLoadCartDrawer();},1500);
}

async function handleAddToCart(e) {
  const target = e.target.matches('#quick-view-add-btn') ? e.target : e.closest('#quick-view-add-btn');
  const frenzy_scripts = document.getElementById("frenzyCDN").dataset;
  const frenzy_company_id = frenzy_scripts.company_id;
  const frenzy_location_id = frenzy_scripts.location_id;
  const eventPayload = {
    company_id: frenzy_company_id ? frenzy_company_id : null,
    country: Shopify.country ? Shopify.country : null,
    event_name: 'add_to_cart',
    location_id: frenzy_location_id ? frenzy_location_id : null,
    query_id: target?.dataset?.request_id ? target?.dataset?.request_id : null,
    config_id: target?.dataset?.config_id ? target?.dataset?.config_id : null,
    session_id: window.frenzySessionId,
    shop: Shopify.shop ? Shopify.shop : null,
    sku: `${target?.dataset?.sku?.split('_')[0]}_${target.dataset.variantId}`,
    state: Shopify.trackingConsent.getRegion().slice(2,4),
    user_id: window.frenzyUserId
  }
  window.frenzyEventCallback(eventPayload);

  const addToCartBtn = document.getElementById('quick-view-add-btn');
  const variantId = addToCartBtn.dataset.variantId;
  if (!variantId) return;

  const skuSel = target.dataset.sku;
  let productHandle = document.querySelector(`.frenzy_grid .frenzy_product_item[data-sku="${skuSel}"] quick-add-button`).dataset.productHandle;
  productHandle = productHandle.split('?variant=')[0];
  console.log('skuSel ',skuSel);
  console.log('productHandle ',productHandle);

  const response = await fetch(`/products/${productHandle}`);
  const productHTML = await response.text();

  // Convert HTML string → DOM
  const parser = new DOMParser();
  const doc = parser.parseFromString(productHTML, 'text/html');

  const input = doc.querySelector(`.cust_variantWrap input[data-varid="${variantId}"]`);

  const has_sale_tag = parseInt(input?.value);
  console.log('has_sale_tag')

  let formData = { id: variantId, quantity: 1, properties: {_config_id:target?.dataset?.config_id,_event_name:`${target?.dataset?.name+'_add_to_cart'}`,_query_id:target?.dataset?.request_id,_sku:`${target?.dataset?.sku?.split('_')[0]}_${target.dataset.variantId}`,_user_id:window.frenzyUserId} };
  if (has_sale_tag === 1){
    formData = { id: variantId, quantity: 1, properties: {_sale_tag:'red_line', _LPROP:'Final Sale', _config_id:target?.dataset?.config_id,_event_name:`${target?.dataset?.name+'_add_to_cart'}`,_query_id:target?.dataset?.request_id,_sku:`${target?.dataset?.sku?.split('_')[0]}_${target.dataset.variantId}`,_user_id:window.frenzyUserId} };
  }

  const resp = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    //body: JSON.stringify({ id: variantId, quantity: 1, properties: {_config_id:target?.dataset?.config_id,_event_name:`${target?.dataset?.name+'_add_to_cart'}`,_query_id:target?.dataset?.request_id,_sku:`${target?.dataset?.sku?.split('_')[0]}_${target.dataset.variantId}`,_user_id:window.frenzyUserId} })
    body: JSON.stringify(formData)
  });
  addToCartBtn.textContent = 'Added'; 
  window.GTMEventBus?.publish(eventConstants.ADD_TO_CART, {product: currentProduct, selectedVariant: frenzySelectedVariant});
  document.querySelector('#header-group').classList.remove('search-opened');
  updateCartDrawer();
  // closeModal();
}

function openModal() {
  document.querySelector('.quick-view-modal').classList.remove('display_none');
  document.body.style.overflow = 'hidden';
}

function closeModal(e) {
  if (e) {
    e.preventDefault();
  }
  const videoContainer = document.querySelector('#video_container');
  if (videoContainer) {
    videoContainer.classList.add('display_none');
    videoContainer.innerHTML = "";
  }
  document.querySelector('.quick-view-modal').classList.add('display_none');
  document.body.style.overflow = '';
}
